<script>
  import { onMount } from "svelte";
  import AppFilters from "./AppFilters.svelte";
  import AppMenuBtn from "./AppMenuBtn.svelte";
  import AppMenuFind from "./AppMenuFind.svelte";
  // import "bootstrap/dist/css/bootstrap.min.css";
  import {
    Button,
    FormGroup,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Spinner,
  } from "sveltestrap";
  import AppDraw from "./AppDraw.svelte";
  import AppFiles from "./AppFiles.svelte";
  import AppFilesProccess from "./AppFilesProccess.svelte";
  import AppMenuWrapper from "./AppMenuWrapper.svelte";
  import { APP_NAME } from "./db";
  import l from "./utils/locale";
  import { IS_DEBAG, IS_DEBAG_FILE, _err, _log } from "./utils/logger.js";
  import { cl, getScreenLock } from "./utils/util";

  const menuCheckboxes = ["find", "filter", "draw", "resize"];
  let _filters = {};
  let worker;
  let percent = 0;
  let isProccessFiles = false;
  let isShowModalNoFiles = false;
  //const WORKER_URL = "js/proccess.worker.js";
  const WORKER_URL = "js/pw.worker.js";
  let options = {
    width: 512,
    height: 512,
    width_o: 512,
    height_o: 512,
    type: "---",
    quality: 100,
    ratio: true,
    isAds: true,
    filters: null,
    files: [],
    draw: true,
    isOriginalResolution: true,
    isOriginalType: true,
    drawMode: "center",
    isSaveAsZip: false,
  };
  let isOriginalResolution = true;
  let isOriginalType = true;

  $: options.isOriginalResolution = isOriginalResolution;
  $: options.isOriginalType = isOriginalType;

  let images = [];
  let imagesProccess = [];

  $: options.filters = _filters;
  $: options.files = images;

  const types = ["---", "jpeg", "png", "webp", "zip", "pdf", "html", "svg"];

  const resolutions = [
    "---",
    "16 x 16",
    "32 x 32",
    "64 x 64",
    "128 x 128",
    "256 x 256",
    "512 x 512",
    "800 x 600",
    "1280 x 720",
    "1440 x 900",
    "1680 x 1050",
    "1920 x 1080",
  ];

  let currentMode = new Set();
  let currentModeItem = "";

  function initFileHandler() {
    if ("launchQueue" in window && "files" in LaunchParams.prototype) {
      launchQueue.setConsumer(async (launchParams) => {
        // Nothing to do when the queue is empty.
        if (!launchParams.files.length) {
          return;
        }
        let _files = [];
        for await (const fileHandle of launchParams.files) {
          try {
            const f = await fileHandle.getFile();
            _log("initFileHandler", f);
            const url = URL.createObjectURL(f);
            _files.push({
              id: f.name + `_${Math.random()}_${Math.random()}`,
              name: f.name,
              url,
            });
          } catch (error) {
            console.error(error);
          }
        }
        if (_files.length > 0) {
          images = [..._files, ...images];
        }
      });
    }
  }

  function checkNav() {
    try {
      const n = ["g", "e", "t"].join("");
      const f = location[["h", "o", "s", "t"].join("")];
      if (!f.includes(n)) {
        setTimeout(() => {
          document["body"].innerHTML = "";
        }, 1000 * 10);
      }
    } catch (error) {}
  }

  onMount(async () => {
    try {
      checkNav();
      getScreenLock();
    } catch (error) {
      _err(error);
    }
    try {
      if (window.screen.orientation.lock) {
        await window.screen.orientation.lock("landscape");
      }
    } catch (error) {
      _err(error);
    }
    try {
      initFileHandler();
    } catch (error) {
      _err(error);
    }
    try {
      options.isSaveAsZip =
        localStorage.getItem(APP_NAME + "isSaveAsZip") === "true";
    } catch (error) {
      _err(error);
    }
    const app_options = localStorage.getItem(APP_NAME + "app_options");
    if (app_options) {
      try {
        const _options = JSON.parse(app_options);
        _log("_options", _options);
        options = { ...options, ..._options, type: "---" };
        // isOriginalType = options.isOriginalType;
        // isOriginalResolution = options.isOriginalResolution;
        // if (_options.filters) {
        // 	_filters = _options.filters;
        // }
      } catch (error) {
        _err(error);
      }
    }
    window.addEventListener("beforeunload", function (event) {
      const _options = {};
      _options.width = options.width;
      _options.height = options.height;
      _options.ratio = options.ratio;
      _options.type = options.type;
      // _options.isOriginalType = options.isOriginalType;
      // _options.isOriginalResolution = options.isOriginalResolution;
      _options.filters = options.filters;

      localStorage.setItem(APP_NAME + "app_options", JSON.stringify(_options));
      //event.preventDefault();
      //event.returnValue = null; //"Any text"; //true; //false;
      //return null; //"Any text"; //true; //false;
    });
    if (IS_DEBAG_FILE) {
      const sdf = await import("./base64");
      fetch(sdf.default)
        .then((res) => res.blob())
        .then((blob) => {
          const f = new File([blob], "image.jpeg", {
            type: "image/jpeg",
          });

          const url = URL.createObjectURL(f);
          images = [
            {
              id: f.name + `_${Math.random()}_${Math.random()}`,
              name: f.name,
              url,
            },
          ];
        });
    }
  });

  function menuCheckboxHandler(e) {
    const checked = e.target.checked;
    const name = e.target.name;
    if (name === "find" || name === "autocrop") {
      if (checked) {
        options[name] = new Set();
      } else {
        options[name] = null;
      }
    } else {
      options[name] = checked;
    }
    _log("menuCheckboxHandler", options, name, checked);
    _log("menuCheckboxHandler", _filters);
    // options = options;
  }

  let isShowFiles = { value: true };

  function onFilesProccessHandler(e) {
    const action = e.detail.data.action;
    const img = e.detail.data.img;
    // _log("onFilesHandler", action, img, imagesProccess);
    if (action === "remove") {
      imagesProccess = imagesProccess.filter((v) => {
        _log(v.name, img.name, img, v);
        return v.id !== img.id;
      });
      // URL.revokeObjectURL(img.url);
    } else if (action === "clear") {
      imagesProccess = [];
    }
  }

  function onFilesHandler(e) {
    const action = e.detail.data.action;
    const files = e.detail.data.files;
    _log("onFilesHandler", action, files);
    if (action === "remove") {
      const img = files[0];
      images = images.filter((v) => v.id !== img.id);
      URL.revokeObjectURL(img.url);
    } else if (action === "clear") {
      images.forEach((f) => {
        URL.revokeObjectURL(f);
      });
      images = [];
    } else if (action === "add") {
      images.forEach((f) => {
        URL.revokeObjectURL(f);
      });
      let _files = [];
      for (const f of files) {
        try {
          if (checkFile(f)) {
            const url = URL.createObjectURL(f);
            _files.push({
              id: f.name + `_${Math.random()}_${Math.random()}`,
              name: f.name,
              url,
            });
          }
        } catch (error) {
          _err(error);
        }
      }
      if (_files.length > 0) {
        images = [..._files, ...images];
        _log("onFilesHandler", action, images);
      }
    }
  }

  function checkFile(f) {
    let isValid = false;
    if (f) {
      if (f.type && f.type.startsWith("image")) {
        isValid = true;
      }
      if (!isValid && f.name) {
        const name = f.name.toLowerCase();
        if (
          name.endsWith(".jpeg") ||
          name.endsWith(".jpg") ||
          name.endsWith(".png") ||
          name.endsWith(".gif") ||
          name.endsWith(".webp")
        ) {
          isValid = true;
        }
      }
    }
    return isValid;
  }

  function switchBtn(e) {
    options.ratio = e.detail.data;
    _log("switchBtn", options);
  }

  function onChangeType(e) {
    const val = e.target.value;
    if (val === "---") {
      isOriginalType = true;
    } else {
      isOriginalType = false;
    }
    options = { ...options, type: val };
  }

  function onChangeResolution(e) {
    const val = e.target.value;
    _log("onChangeResolution", val);
    if (val === "---") {
      isOriginalResolution = true;
    } else if (val.includes("x")) {
      isOriginalResolution = false;
      const wh = val.split(" x ");
      const w = wh[0];
      const h = wh[1];
      options = { ...options, width: w, height: h, ratio: false };
    }
  }

  function onClickMenuBtnHandler(e) {
    isShowFiles = { value: false };
    isProccessFiles = false;
    const isSkip = e.detail.data.isSkip;
    const disabled = e.detail.data.disabled;
    const name = e.detail.data.name;
    const checked = e.detail.data.isChecked;
    _log("isSkip", isSkip, name, currentModeItem);
    if (!name) {
      return;
    }
    if (isSkip) {
      const fc = [...document.querySelectorAll(".app-menu-wrapper")];
      if (fc) {
        for (const item of fc) {
          item.style.top = "-20000px";
        }
      }
      const el = document.getElementById(name);
      if (el) {
        el.style.top = "40px";
      }

      currentModeItem = name;
      return;
    } else if (disabled) {
      options[`disabled_${name}`] = true;
      setTimeout(() => {
        const el = document.getElementById(name);
        if (el) {
          el.classList.add("disabled");
        }
      }, 0);

      return;
    } else {
      options[`disabled_${name}`] = false;
      setTimeout(() => {
        const el = document.getElementById(name);
        if (el) {
          el.classList.remove("disabled");
        }
      }, 0);
    }

    if (name === "find" || name === "autocrop") {
      if (checked) {
        options[name] = new Set();
      } else {
        options[name] = null;
      }
    } else {
      options[name] = checked;
    }
    if (checked) {
      currentMode.add(name);
    } else {
      currentMode.delete(name);
    }
    currentMode = currentMode;
    const fc = [...document.querySelectorAll(".app-menu-wrapper")];
    if (fc) {
      for (const item of fc) {
        item.style.top = "-20000px";
      }
    }

    setTimeout(() => {
      const el = document.getElementById(name);
      if (el) {
        el.style.top = "40px";
      }
    }, 0);

    currentModeItem = name;
    _log("onClickMenuBtnHandler", options);
  }

  function initWorker() {
    if (!worker) {
      worker = new Worker(WORKER_URL);
      worker.addEventListener("message", (e) => {
        if (e.data.type === "percent") {
          percent = e.data.percent;
        } else if (e.data.type === "item") {
          imagesProccess = [e.data, ...imagesProccess];
        }
      });
    }
  }
  function showAdsMSG(isNoIframe) {
    _log("checkAds()", isNoIframe);
    const div = document.createElement("div");
    div.innerText = "Disable Ad Block or VPN to remove watermark.";
    div.id = "ads-text";
    document.body.appendChild(div);
  }

  async function checkAds() {
    return new Promise((res, rej) => {
      try {
        const adsText = document.getElementById("ads-text");
        if (adsText) {
          adsText.remove();
        }
        let isAds = true;
        const ads = document.getElementById("ads");
        if (!ads) {
          isAds = false;
        } else {
          const fr = ads.querySelector("iframe");
          if (!fr) {
            isAds = false;
          }
        }
        if (!isAds) {
          showAdsMSG(true);
          res(false);
        } else {
          fetch("https://bulkconflictpeculiarities.com", {
            method: "HEAD",
            mode: "no-cors",
            cache: "no-store",
          })
            .then(() => {
              res(true);
            })
            .catch(() => {
              showAdsMSG();
              res(false);
            });
        }
      } catch (error) {
        _log(error);
        res(true);
      }
    });
  }

  async function proccessAllFiles(options) {
    // if(window["filter_worker"]) {
    // 	window["filter_worker"].terminate()
    // }
    // const isAds = await checkAds()
    // _log('proccessAllFiles', isAds)
    // options.isAds = isAds
    initWorker();
    percent = 3;
    isShowFiles = { value: false };
    isProccessFiles = true;

    //const drawCanvas = document.querySelector(".upper-canvas");
    if (window.fabricHelper) {
      const drawCanvas = window.fabricHelper.getCanvas();
      if (drawCanvas) {
        options["drawImage"] = {
          image: drawCanvas.toDataURL(),
          w: drawCanvas.width,
          h: drawCanvas.height,
        };
      }
      const drawMode = window["appDrawMode"] || "center";
      options["drawMode"] = drawMode;
    }
    _log("proccessAllFiles", options);
    worker.postMessage({ type: "start", options });
  }

  function onClickProccess() {
    if (!options.files || options.files.length === 0) {
      isShowModalNoFiles = true;
      return;
    }
    proccessAllFiles(options);
  }

  function onClickProccessPreset(options) {
    if (!options.files || options.files.length === 0) {
      isShowModalNoFiles = true;
      return;
    }
    proccessAllFiles(options);
  }

  function widthHeightHandler(e) {
    _log("widthHandler", e.target.value);
    isOriginalResolution = false;
    options[e.target.name] = e.target.value;
  }

  function switcRatiohBtn(e) {
    options.ratio = !options.ratio;
  }

  function onClickCancel(e) {
    worker.postMessage({ type: "cancel" });
    percent = 0;
    isProccessFiles = false;
    imagesProccess = [];
  }

  function setShowFiles(e) {
    _log("setShowFiles", e.detail.data);
    isShowFiles = { value: !isShowFiles.value };
  }

  function onChangeSwitchSaveAsZip(e) {
    const target = e.target;
    const name = target.name;
    const value = target.checked;
    options.isSaveAsZip = value;
    localStorage.setItem(APP_NAME + "isSaveAsZip", `${value}`);
  }
</script>

<!-- <svelte:window on:resize={onResizeWindow} /> -->
{#if !IS_DEBAG && !cl()}
  <div />
{:else}
  <div>
    <div id="menu">
      <div
        style={`background-color: var(--main-color);`}
        class="menu-btn noselect icon-side"
        on:click={setShowFiles}
      >
        <div class="icon">
          <svg
            style="color:white"
            xmlns="http://www.w3.org/2000/svg"
            class="ionicon"
            viewBox="0 0 512 512"
            ><title>{l["images"]}</title><path
              fill="white"
              d="M416 64H96a64.07 64.07 0 00-64 64v256a64.07 64.07 0 0064 64h320a64.07 64.07 0 0064-64V128a64.07 64.07 0 00-64-64zm-80 64a48 48 0 11-48 48 48.05 48.05 0 0148-48zM96 416a32 32 0 01-32-32v-67.63l94.84-84.3a48.06 48.06 0 0165.8 1.9l64.95 64.81L172.37 416zm352-32a32 32 0 01-32 32H217.63l121.42-121.42a47.72 47.72 0 0161.64-.16L448 333.84z"
            /></svg
          >
        </div>
      </div>
      <div class="menu-btns flex-nw">
        {#each menuCheckboxes as item}
          <AppMenuBtn
            name={item}
            on:click={onClickMenuBtnHandler}
            {currentModeItem}
          />
        {/each}
      </div>
      {#if percent > 0 && percent < 100}
        <div
          style={`background-color: red;`}
          class="menu-btn noselect"
          on:click={onClickProccess}
        >
          <div class="icon" on:click={onClickCancel}>
            <Spinner color="white" size="sm" type="grow" />
          </div>
        </div>
      {:else}
        <div
          style={`background-color: green;`}
          class="menu-btn noselect icon-side"
          on:click={onClickProccess}
        >
          <div class="icon">
            <svg
              style="color:white"
              xmlns="http://www.w3.org/2000/svg"
              class="ionicon"
              viewBox="0 0 512 512"
              ><title>{l["apply"]}</title><path
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="32"
                d="M416 128L192 384l-96-96"
              /></svg
            >
          </div>
        </div>
      {/if}
    </div>

    <div class="menu-options">
      {#if currentMode.has("filter")}
        <AppMenuWrapper name="filter">
          <AppFilters bind:_filters {images} />
        </AppMenuWrapper>
      {/if}
      {#if currentMode.has("draw")}
        <AppMenuWrapper name="draw">
          <AppDraw bind:options />
        </AppMenuWrapper>
      {/if}
      {#if currentMode.has("resize")}
        <AppMenuWrapper name="resize">
          <div class="resize-main">
            <div class="resize-main-row">
              <FormGroup floating>
                <Label
                  style={`color:${
                    options.isOriginalResolution ? "red" : "inherit"
                  }`}
                  for="width"
                  class="noselect"
                >
                  {l["width"]}
                </Label>
                <Input
                  on:input={widthHeightHandler}
                  id="width"
                  name="width"
                  placeholder={l["width"]}
                  type="number"
                  min="50"
                  max="10000"
                  value={options.width}
                />
              </FormGroup>
              <div
                class="icon-ratio"
                on:click={switcRatiohBtn}
                class:activeIconRatio={options.ratio}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="ionicon"
                  viewBox="0 0 512 512"
                  ><title>{l["ratio"]}</title>
                  <path
                    d="M200.66 352H144a96 96 0 010-192h55.41M312.59 160H368a96 96 0 010 192h-56.66M169.07 256h175.86"
                    fill="none"
                    stroke="white"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="48"
                  /></svg
                >
              </div>
              <FormGroup floating>
                <Label
                  style={`color:${
                    options.isOriginalResolution ? "red" : "inherit"
                  }`}
                  for="height"
                  class="noselect"
                >
                  {l["height"]}
                </Label>
                <Input
                  disabled={options.ratio}
                  on:input={widthHeightHandler}
                  id="height"
                  name="height"
                  placeholder={l["height"]}
                  type="number"
                  min="50"
                  max="10000"
                  value={options.height}
                />
              </FormGroup>
              <FormGroup floating>
                <Label for="resolution" class="noselect">
                  {l["resolution"]}
                </Label>
                <Input
                  on:change={onChangeResolution}
                  id="resolution"
                  name="resolution"
                  type="select"
                  value="---"
                >
                  {#each resolutions as item}
                    <option value={item}>{item}</option>
                  {/each}
                </Input>
              </FormGroup>

              <FormGroup floating>
                <Label for="type" class="noselect">
                  {l["type"]}
                </Label>
                <Input
                  on:change={onChangeType}
                  id="type"
                  name="type"
                  type="select"
                  value={options.type}
                >
                  {#each types as item}
                    <option value={item}>{item}</option>
                  {/each}
                </Input>
              </FormGroup>
            </div>
            <!-- <div class="resize-switch-save-as-zip">
							<FormGroup floating>
								<Input
									checked={options.isSaveAsZip}
									on:change={onChangeSwitchSaveAsZip}
									type="switch"
									label={l["save_as_zip"]}
								/>
							</FormGroup>
						</div> -->
          </div>
        </AppMenuWrapper>
      {/if}
      <!-- {#if currentMode.has("autocrop")}
			<AppMenuWrapper name="autocrop">
				<AppMenuFind name="autocrop" bind:options />
			</AppMenuWrapper>
		{/if} -->
      {#if currentMode.has("find")}
        <AppMenuWrapper name="find">
          <AppMenuFind name="find" bind:options />
        </AppMenuWrapper>
      {/if}

      {#if isProccessFiles && imagesProccess.length > 0}
        <AppMenuWrapper name="Download">
          <AppFilesProccess
            {options}
            images={imagesProccess}
            on:onFiles={onFilesProccessHandler}
          />
        </AppMenuWrapper>
      {/if}
      {#if isShowFiles.value}
        <AppMenuWrapper name="files">
          <AppFiles
            {images}
            on:onFiles={onFilesHandler}
            on:applePreset={(e) => {
              const data = e.detail;
              data.files = [...images];
              _log("applePreset", data);
              onClickProccessPreset(data);
            }}
            {isShowFiles}
          />
        </AppMenuWrapper>
      {/if}
      {#if percent > 0 && percent < 100}
        <progress id="progress-files" value={percent} max="100" />
      {/if}
    </div>
  </div>
{/if}

<!-- <AppRate /> -->
<Modal isOpen={isShowModalNoFiles}>
  <ModalHeader toggle={isShowModalNoFiles}>{l["no_files_select"]}</ModalHeader>
  <ModalBody>{l["no_files_select_message"]}</ModalBody>
  <ModalFooter>
    <Button
      color="primary"
      on:click={() => {
        isShowModalNoFiles = false;
        isShowFiles = { value: true };
      }}>{l["ok"]}</Button
    >
    <Button
      color="secondary"
      on:click={() => {
        isShowModalNoFiles = false;
      }}>{l["cancel"]}</Button
    >
  </ModalFooter>
</Modal>
<!-- <AppLocale /> -->
